"use strict";
import request from "@/utils/request"; // 引入封装的请求函数
// 查询场次奖品列表
export function listActivityPrizeInf(params) {
  return request({
      url: "/hwse/activityPrizeInf/list",
      method: 'GET',
      params,
  })
}

// 抽奖接口
export function activityPrizeUserPd (data) {
  return request({
    url: "/hwse/activityPrizeUser/pd",
    method: "POST",
    data,
    params: data,
  })
}

// 获取当前场次参与用户信息
export function activityUserInfList(params) {
  return request({
    url: "/hwse/activityUserInf/list",
    method: "GET",
    params,
  });
}

// 获取当前场次中奖信息;
export function activityPrizeUserList (params) {
  return request({
    url: "/hwse/activityPrizeUser/list",
    method: "GET",
    params,
  });
}

export function activityPrizeUserPdusers (params) {
  return request({
    url: "/hwse/activityPrizeUser/pdusers",
    method: "GET",
    params,
  });
}

export function queryInfList (params) {
  return request({
    url: "/hwse/queryInf/list",
    method: "GET",
    params,
  });
}

export function ossinf(id) {
  return request({
    url: '/resource/oss/inf/'+id,
    method: 'get',
  })
}

// 当前场次基础信息
export function activityInf(pkId) {
  return request({
    url: "/hwse/activityInf/" + pkId,
    method: "GET",
  });
}